import dayjs, { Dayjs } from 'dayjs';

export type PastPresentFuture = 'past' | 'present' | 'future';

export class TimeSpan {
  from: Dayjs;
  to: Dayjs;
  constructor(from: any, to: any) {
    this.from = dayjs(from);
    this.to = dayjs(to);
  }
  static relative(fromDelta: any, toDelta: any, now = dayjs()) {
    return new TimeSpan(now.add(fromDelta), now.add(toDelta));
  }
  isPast(now: Dayjs = dayjs()) {
    return now.isAfter(this.to);
  }
  isPresent(now: Dayjs = dayjs()) {
    return now.isAfter(this.from) && now.isBefore(this.to);
  }
  isFuture(now: Dayjs = dayjs()) {
    return now.isBefore(this.from);
  }
  isValid() {
    return this.from.isSameOrBefore(this.to);
  }
  pastPresentFuture(now: Dayjs = dayjs()): PastPresentFuture {
    if (this.isPast(now)) return 'past';
    if (this.isFuture(now)) return 'future';
    return 'present';
  }
}
